import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import CampaignListScreen from "../screens/CampaignListScreen";

import ReviewListScreen from "../screens/ReviewListScreen";
import NewReviewScreen from "../screens/NewReviewScreen";
import EditReviewScreen from '../screens/EditReviewScreen';
import UserFollowUpScreen from "../screens/UserFollowUpScreen";

type ReviewsRouterProps = RouteComponentProps;

const ReviewsRouter: React.FC<ReviewsRouterProps> = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}/new`} component={NewReviewScreen} />

    <Route exact path={`${match.path}/campaigns`} component={CampaignListScreen} />

    <Route exact path={`${match.path}/next`} component={ReviewListScreen} />
    <Route exact path={`${match.path}/ongoing`} component={ReviewListScreen} />
    <Route exact path={`${match.path}/finished`} component={ReviewListScreen} />
    <Route exact path={`${match.path}/available`} component={ReviewListScreen} />

    <Route path={`${match.path}/new`} component={NewReviewScreen} />
    <Route exact path={`${match.path}/:id/edit`} component={EditReviewScreen} />
    <Route exact path={`${match.path}/:id`} component={UserFollowUpScreen} />
    <Route exact path={`${match.path}`} component={ReviewListScreen} />
  </Switch>
);

export default ReviewsRouter;
